<template>
  <nav class="sidebar-navigation">
    <ul>

        <router-link active-class='active' tag='li' class="nav_list_item" to="/" exact>
          <i class="far fa-user"></i>
        <span class="tooltip">Me</span>
        </router-link>

        <router-link active-class='active' tag='li' class="nav_list_item " to="/works">
          <i class="fas fa-layer-group"></i>
        <span class="tooltip">Works</span>
        </router-link>

        <router-link active-class='active' tag='li' class="nav_list_item " to="/links">
          <i class="fas fa-address-card"></i>
        <span class="tooltip">Contacts</span>
        </router-link>

      <li class="nav_list_item disabled">
        <i class="far fa-moon"></i>
        <span class="tooltip">Night or Day</span>
      </li>
    </ul>
  </nav>
</template>

<script>



export default {
  name: "sidebar",
  // methods: {
  //   changeButtonStyle: function(){
  //     const menu = document.querySelectorAll("ul li");
  //     const lis = document.querySelectorAll("li");
  //     [...menu].forEach(nav_item =>
  //       nav_item.addEventListener("click", function() {
  //         [...lis].forEach(li => li.classList.remove("active"));
  //         nav_item.classList.add("active");
  //       })
  //     );
  //   }
  // }
};
</script>

<style>
a {
  color: inherit;
  text-decoration: none;
}
.disabled{
  background-color: #000000;
 
}
.disabled:hover{
   cursor: no-drop;
}
.sidebar-navigation {
  display: flex;
  min-height: 100vh;
  height: 100%;
  width: 60px;
  background-color: #1d2340;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}
.sidebar-navigation ul {
  list-style: none;
  text-align: center;
  color: white;
  margin: 0;
  padding: 0;
  width: 100%;
}
.sidebar-navigation ul li {
  /* padding: 28px; */
  width: 60px;
  height: 60px;
  cursor: pointer;
  transition: all ease-out 120ms;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar-navigation ul li i {
  display: block;
  font-size: 24px;
  transition: all ease 450ms;
}
.sidebar-navigation ul li .tooltip {
  display: inline-block;
  position: absolute;
  background-color: #313443;
  padding: 8px 15px;
  border-radius: 3px;
  margin-top: -26px;
  left: 90px;
  opacity: 0;
  visibility: hidden;
  font-size: 13px;
  letter-spacing: 0.5px;
}
.sidebar-navigation ul li .tooltip:before {
  content: "";
  display: block;
  position: absolute;
  left: -4px;
  top: 10px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  width: 10px;
  height: 10px;
  background-color: inherit;
}
.sidebar-navigation ul li:hover {
  background-color: #222e53;
}
.sidebar-navigation ul li:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
.sidebar-navigation ul li.active {
  background-color: #222e53;
}
.sidebar-navigation ul li.active i {
  color: #e84118;
}

@media (max-width: 560px) {
  .sidebar-navigation {
    height: 60px;
    min-height: 1px;
    width: 100vw;
  }
  .sidebar-navigation ul {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sidebar-navigation ul li .tooltip{
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/aside.vue